import { Button } from '@/app/common/Buttons/Button';
import { getButtonVariant, shouldOpenInNewTab } from '@workspace/lib';
import { stripInvisibles } from '@workspace/constants';
import type { MiddleBannerButton } from './middle-banner.types';

export const renderButton = (buttonData: MiddleBannerButton) => {
  if (!buttonData || !buttonData.isActive || !buttonData.linkOptional?.type) return null;

  const label = stripInvisibles(buttonData.label || '').trim();

  return (
    <div className="order-2 w-full md:w-auto flex flex-wrap gap-3 justify-center">
      <Button
        variant={getButtonVariant(buttonData.style)}
        url={buttonData.linkOptional?.url || '#'}
        openInNewTab={shouldOpenInNewTab(buttonData.linkOptional)}
        className="w-full px-sm gap-xs rounded-sm"
      >
        <span className="flex-1 text-center">{label}</span>
      </Button>
    </div>
  );
};
